import {FC} from 'react'
import clsx from 'clsx'
import {InvoicePrintPage, PRINT_PAGE_TITLES} from '../core/printPagePreference'
import './printPageIntro.scss'

const OPTIONS: {page: InvoicePrintPage; description: string; badge?: string}[] = [
  {
    page: 'new',
    badge: 'پیشنهادی',
    description:
      'برگه‌های A4 با جمع هر صفحه؛ بدون ورود به پنل با لینک یا QR کد باز می‌شود و نسخهٔ موبایل دارد.',
  },
  {
    page: 'classic',
    description:
      'همان صفحه‌ای که تا امروز صورتحساب‌ها با آن باز می‌شد؛ فقط برای کاربران پنل باز می‌شود.',
  },
]

/** A small drawing of each page: stacked A4 sheets with page totals, or the earlier single sheet. */
export const PrintPageArt: FC<{page: InvoicePrintPage}> = ({page}) => (
  <span className={clsx('ppi-art', `ppi-art--${page}`)} aria-hidden='true'>
    {page === 'new' && (
      <>
        <span className='ppi-art__sheet ppi-art__sheet--back2' />
        <span className='ppi-art__sheet ppi-art__sheet--back1' />
      </>
    )}
    <span className='ppi-art__sheet ppi-art__sheet--front'>
      <span className='ppi-art__head' />
      <span className='ppi-art__line' />
      <span className='ppi-art__line ppi-art__line--short' />
      <span className='ppi-art__grid'>
        <span />
        <span />
        <span />
        <span />
      </span>
      {page === 'new' && <span className='ppi-art__total' />}
    </span>
  </span>
)

/**
 * The two print pages as radio cards. Used by the business settings and by the announcement of
 * the new page.
 */
export const PrintPageChoice: FC<{
  name: string
  value: InvoicePrintPage
  onChange: (page: InvoicePrintPage) => void
  disabled?: boolean
  /** The page whose save is in flight, to show a spinner on it. */
  savingPage?: InvoicePrintPage
}> = ({name, value, onChange, disabled, savingPage}) => (
  <div className='ppi-choice' role='radiogroup' aria-label='صفحهٔ چاپ پیش‌فرض'>
    {OPTIONS.map((option) => {
      const id = `${name}-${option.page}`
      const checked = value === option.page
      return (
        <label
          key={option.page}
          htmlFor={id}
          className={clsx('ppi-choice__card', {
            'ppi-choice__card--checked': checked,
            'ppi-choice__card--disabled': disabled,
          })}
        >
          <input
            id={id}
            type='radio'
            className='ppi-choice__input'
            name={name}
            value={option.page}
            checked={checked}
            disabled={disabled}
            onChange={() => onChange(option.page)}
          />
          <PrintPageArt page={option.page} />
          <span className='ppi-choice__text'>
            <span className='ppi-choice__title'>
              {PRINT_PAGE_TITLES[option.page]}
              {option.badge && <span className='ppi-choice__badge'>{option.badge}</span>}
            </span>
            <span className='ppi-choice__description'>{option.description}</span>
          </span>
          <span className='ppi-choice__mark' aria-hidden='true'>
            {savingPage === option.page ? (
              <span className='spinner-border spinner-border-sm' />
            ) : (
              <i className={clsx('las', checked ? 'la-check-circle' : 'la-circle')} />
            )}
          </span>
        </label>
      )
    })}
  </div>
)
